import React, { Fragment, useState, useContext, ChangeEvent } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  TableSortLabel,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { MainContext } from "../../context/main";
import { LangContext } from "../../context/lang";
import { IParamQuery } from "../../interface/project";
import clsx from "clsx";

const useStyle = makeStyles((theme: Theme) => ({
  headerColumn: {
    borderBottom: "unset",
    // fontFamily: ["Montserrat-Medium", "Kanit-Medium"].join(","),
  },
  headerCellCollapse: { padding: `0px ${theme.spacing(2)}px` },
  textInput: { "& input": { padding: theme.spacing(1), fontSize: 14 } },
  selectInput: { padding: theme.spacing(1), fontSize: 14 },
  searchBtn: { textTransform: "unset" },
  clearBtn: { color: theme.palette.error.main },
}));

interface IProjectHeaderTable {
  paramQuery: IParamQuery;
  setparamQuery: Function;
  queryProjects: Function;
  clearParam: Function;
  onSortDate: Function;
}

const ProjectHeaderTable = (props: IProjectHeaderTable) => {
  const classes = useStyle();
  const { paramQuery, setparamQuery } = props;
  const [filter, setfilter] = useState<Boolean>(false);
  const { userInfo } = useContext(MainContext);
  const { lang } = useContext(LangContext);

  const checkPermission = (role: string | undefined) =>
    role !== "customer" ? true : false;

  const _onChangeText = (e: ChangeEvent<HTMLInputElement>) => {
    setparamQuery({ ...paramQuery, [e.target.name]: e.target.value });
  };

  const _onChangeStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
    setparamQuery({ ...paramQuery, status: event.target.value as number });
  };

  const _onSearch = () => {
    props.queryProjects();
  };

  return (
    <Fragment>
      <TableRow>
        {checkPermission(userInfo?.role) && (
          <TableCell
            className={classes.headerColumn}
            align="center"
            style={{ width: 100 }}
          >
            {lang.data.assign}
          </TableCell>
        )}
        <TableCell
          className={classes.headerColumn}
          align="center"
          style={{ width: 180 }}
        >
          {lang.data.workOrderNo}
        </TableCell>
        <TableCell className={classes.headerColumn}>
          {lang.data.customerName}
        </TableCell>
        <TableCell
          align="center"
          className={classes.headerColumn}
          sortDirection={paramQuery.order}
        >
          <TableSortLabel
            active
            direction={paramQuery.order}
            onClick={() => {
              console.log(paramQuery);
              props.onSortDate();
            }}
            // direction={paramQuery.order}
          >
            {lang.data.createDate}
          </TableSortLabel>
        </TableCell>
        <TableCell align="center" className={classes.headerColumn}>
          {lang.data.status}
        </TableCell>
        <TableCell align="center" className={classes.headerColumn}>
          <IconButton
            size="small"
            onClick={() => {
              setfilter(!filter);
            }}
          >
            <Search />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        {checkPermission(userInfo?.role) && (
          <TableCell className={classes.headerCellCollapse} align="center" />
        )}
        <TableCell className={classes.headerCellCollapse} colSpan={2}>
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <TextField
              placeholder="keyword"
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textInput}
              name="keywords"
              onChange={_onChangeText}
              value={paramQuery.keywords}
            />
          </Collapse>
        </TableCell>
        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <TextField
              id="date"
              variant="outlined"
              type="date"
              // defaultValue="2017-05-24"
              className={classes.textInput}
              InputLabelProps={{
                shrink: true,
              }}
              name="createdDate"
              onChange={_onChangeText}
              value={paramQuery.createdDate}
            />
          </Collapse>
        </TableCell>

        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <FormControl variant="outlined" margin="dense">
              <Select
                classes={{ select: classes.selectInput }}
                value={paramQuery.status}
                // defaultValue={3}
                onChange={_onChangeStatus}
              >
                <MenuItem value={-1}>{lang.data.all}</MenuItem>
                <MenuItem value={0}>{lang.data.waitting}</MenuItem>
                <MenuItem value={1}>{lang.data.inProcess}</MenuItem>
                <MenuItem value={2}>{lang.data.complete}</MenuItem>
              </Select>
            </FormControl>
          </Collapse>
        </TableCell>
        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <Button
              className={classes.searchBtn}
              color="primary"
              onClick={_onSearch}
            >
              {lang.data.search}
            </Button>
            <Button
              className={clsx(classes.clearBtn, classes.searchBtn)}
              // color="primary"
              onClick={() => {
                props.clearParam();
              }}
            >
              {lang.data.clear}
            </Button>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default ProjectHeaderTable;
